// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  width: 100%;
  position: relative;
  /* box-sizing: border-box; */
  border-right: 1px solid #eef0f3;
  border-left: 1px solid #eef0f3;
}

a {
  text-decoration: none;
}

.table-overflow-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block !important;
}

.list-text-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B","sourcesContent":[".App {\n  width: 100%;\n  position: relative;\n  /* box-sizing: border-box; */\n  border-right: 1px solid #eef0f3;\n  border-left: 1px solid #eef0f3;\n}\n\na {\n  text-decoration: none;\n}\n\n.table-overflow-hidden {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block !important;\n}\n\n.list-text-center {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
